import { FolderKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";

import { GetMyRoleForFolderFileByIdRequest, GetMyRoleForFolderFileByIdResponse } from "@maven-rest/docs/Folder.dto";
import { FolderUrl } from "@maven-rest/docs/Folder.url";

export function useMyRoleForFolderFileByIdQuery(
  req: GetMyRoleForFolderFileByIdRequest,
  options?: SimpleQueryOptions<GetMyRoleForFolderFileByIdResponse, GetMyRoleForFolderFileByIdRequest>
) {
  return useBaseQuery({
    queryKey: [FolderKey.MyRoleForFolderFileById, String(req.fileId)],
    fnOption: { url: FolderUrl.getMyRoleForFolderFileById(req.fileId), request: req },
    ...options,
  });
}
